import { ExternalConnectionContact, ID } from '@griply/types';
import { dedupeContacts } from '@griply/utils';
import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getExternalConnectionContacts } from 'shared/services/backend-api';

export const queryKey = 'external-connection-contacts';

export type UseExternalConnectionsContactsQueriesOptions = {
  enabled?: boolean;
};

// One suggestion pool across all capable connections, deduped by email. No staleTime
// override: the global Infinity default makes contacts a fetch-once-per-session value —
// the first dialog open pays the callables, every later open reads the cache.
export const useExternalConnectionsContactsQueries = (
  connectionIds: ID[],
  { enabled = true }: UseExternalConnectionsContactsQueriesOptions = {},
): ExternalConnectionContact[] => {
  const queries = useQueries({
    queries: connectionIds.map((id) => ({
      queryKey: [queryKey, id],
      queryFn: () => getExternalConnectionContacts(id),
      // keeps these out of the pending state that, under the global suspense default,
      // suspends the root-mounted EventFormProvider and blanks the app shell
      placeholderData: [],
      enabled,
    })),
  });

  return useMemo(
    () => dedupeContacts(queries.flatMap((query) => query.data ?? [])),
    [queries],
  );
};
